export default {
  loading: false,
  contract_nos: [],
  contract_no: {},
  totalCount: 0,
};
